// La transición de vista de Crear, compartida con la pantalla del Agente
// (ADR-2026-10-16-el-agente-se-ve-como-el-asistente).

import { flushSync } from 'react-dom';

/**
 * Cambia de vista (portada ↔ lienzo) con una transición de vista del navegador cuando la
 * hay: la caja viaja de arriba a abajo en vez de saltar (`view-transition-name` en su
 * envoltorio). Sin soporte, el cambio es inmediato, como antes.
 */
export function conTransicion(cambiar: () => void) {
  const doc = document as Document & { startViewTransition?: (cb: () => void) => void };
  if (typeof doc.startViewTransition === 'function') {
    doc.startViewTransition(() => flushSync(cambiar));
  } else {
    cambiar();
  }
}
